import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../../components/Forms/PresetsTextField'

const StaffWelfare = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <PresetsTextField
        label="Staff Welfare"
        value={opsPlan?.staffWelfare}
        suggestionPath="opsPlan.staffWelfare"
        suggestionLabel="Staff welfare notes from templates"
        setValue={(newValue) => {
          setOpsPlan((prev) => ({
            ...prev,
            staffWelfare: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!opsPlan?.staffWelfare,
        }}
        fullWidth
        multiline
        minRows={2}
        autoComplete="off"
        name="opsplan-staffwelfare"
      />
    </Grid>
  )
}

export default React.memo(StaffWelfare)
